// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"db10de6f","186":"891537a8","212":"43972692","654":"c27c77de","923":"8a54819c"}[chunkId] + ".chunk.css";
};